import { Component, Vue, Prop } from 'vue-property-decorator';
import { Field, TextField, Btn, FormButtonDisabler, IModalComponent, Validations } from '@samc/centricity-core';
import { ServiceVendorDropdownField } from '@/Components/Dropdowns'
import { IOrganization, IReviewTypeVendor } from '@/Interfaces';
import { AjaxHelper } from '@samc/common';

@Component({
  name: 'review-type-vendor-form-modal',
  components: { Field, TextField, Btn, FormButtonDisabler, ServiceVendorDropdownField }
})
export default class ReviewTypeVendorFormModal extends Vue implements IModalComponent {
  @Prop({ required: true }) public verificationToken!: string;
  @Prop() public addCloseProp!: (callback: () => Promise<IReviewTypeVendor | undefined>) => void;
  @Prop() public closeProp!: () => void;

  public dataSourceUrl = '/datasource';
  public serviceVendorId: number | null = null;
  public moniker: string = '';
  public organization: IOrganization | null = null;
  public showValidations: boolean = false;
  public get validations(): Validations<{ serviceVendorId: number, moniker: string,  }> {
    let result: Validations<{ serviceVendorId: number, moniker: string,  }> = {}
    if (this.serviceVendorId === null) {
      result.serviceVendorId = 'Vendor Name Is Required!';
    }
    if (this.moniker.length == 0) {
      result.moniker = 'Vendor Moniker Is Required!';
    }
    if (!result.hasOwnProperty('moniker') && this.moniker.length > 20) {
      result.moniker = 'Vendor Moniker Length Can Have A Maximum Of 20 Characters!';
    }
    return result;
  }

  public mounted() {
    const helper = new AjaxHelper(this.dataSourceUrl, this.verificationToken, null, null);

    this.addCloseProp(async () => {
      this.showValidations = true;
      if (Object.keys(this.validations).length === 0) {
        if (this.serviceVendorId !== null && this.organization !== null && this.serviceVendorId < 0) {
          try {
            this.$loading('Adding New Service Vendor');
            this.organization.isServiceVendor = true;
            this.organization.moniker = this.moniker;
            const vendor = await helper.postData<IOrganization>('organizations', this.organization);
            return { serviceVendorId: vendor.internalId } as IReviewTypeVendor;
          } catch (err: any) {
            this.$log('An error occurred while creating service vendor', err);
            this.$alert.error('An error occurred while creating service vendor');
            return;
          } finally {
            this.$loading();
          }
        }
        return { serviceVendorId: this.serviceVendorId } as IReviewTypeVendor;
      }
    });
  }

  public setOrganization(org: IOrganization | null) {
    this.organization = org;
    this.moniker = org?.moniker ?? '';
  }

  /// Used to create service vendor
  /// isServiceVendor

  /// Used after creation
  /// internalId
}